import { _ModalConfirmacionBasicoV2 } from "./ModalConfirmacionBasicoV2";
import { ModalThingsUtil as util } from "./Utils";

type TStrToModalBotons = util.TStrToModalBotons// "aceptar_cancelar" | "sí_no";

/**
 * @param title titulo de modal @default "Mensaje de confirmación"
 * @param content acepta html, si es `string` se appendiza dentro de un elemento `<label>`
 * @param width @default 400 + "px"
 * @param typeStrModalBotons @default "aceptar_cancelar"
 */
export function _ModalConfirmacionBasico(
    title: (string | null),
    content: string | TSelectionHTML<"htmlelement"> | HTMLElement,
    width = 400,
    typeStrModalBotons: TStrToModalBotons = "aceptar_cancelar"
): Promise<boolean> {
    return _ModalConfirmacionBasicoV2({
        Title: title,
        Content: content,
        Width: width,
        TypeStrModalBotons: typeStrModalBotons,
    })
}